import { string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

const ButtonGroup = ({ className, ...restProps }) => (
  <div
    className={twMerge(
      "flex flex-col gap-4 justify-between items-center w-full my-4 smallMobile:flex-row lg:gap-6",
      className
    )}
    {...restProps}
  />
);

ButtonGroup.propTypes = {
  className: string,
};

export default ButtonGroup;
